export const mergeSortCode = {
    c: `
  #include <stdio.h>
  void merge(int arr[], int l, int m, int r) {
      int i, j, k;
      int n1 = m - l + 1;
      int n2 = r - m;
      int L[n1], R[n2];
      for (i = 0; i < n1; i++)
          L[i] = arr[l + i];
      for (j = 0; j < n2; j++)
          R[j] = arr[m + 1 + j];
      i = 0;
      j = 0;
      k = l;
      while (i < n1 && j < n2) {
          if (L[i] <= R[j]) {
              arr[k] = L[i];
              i++;
          } else {
              arr[k] = R[j];
              j++;
          }
          k++;
      }
      while (i < n1) {
          arr[k] = L[i];
          i++;
          k++;
      }
      while (j < n2) {
          arr[k] = R[j];
          j++;
          k++;
      }
  }
  
  void mergeSort(int arr[], int l, int r) {
      if (l < r) {
          int m = l + (r - l) / 2;
          mergeSort(arr, l, m);
          mergeSort(arr, m + 1, r);
          merge(arr, l, m, r);
      }
  }`,
    cpp: `
  #include <iostream>
  using namespace std;
  
  void merge(int arr[], int l, int m, int r) {
      int n1 = m - l + 1;
      int n2 = r - m;
      int L[n1], R[n2];
      for (int i = 0; i < n1; i++)
          L[i] = arr[l + i];
      for (int j = 0; j < n2; j++)
          R[j] = arr[m + 1 + j];
      int i = 0, j = 0, k = l;
      while (i < n1 && j < n2) {
          if (L[i] <= R[j]) {
              arr[k] = L[i];
              i++;
          } else {
              arr[k] = R[j];
              j++;
          }
          k++;
      }
      while (i < n1) {
          arr[k] = L[i];
          i++;
          k++;
      }
      while (j < n2) {
          arr[k] = R[j];
          j++;
          k++;
      }
  }
  
  void mergeSort(int arr[], int l, int r) {
      if (l < r) {
          int m = l + (r - l) / 2;
          mergeSort(arr, l, m);
          mergeSort(arr, m + 1, r);
          merge(arr, l, m, r);
      }
  }`,
    java: `
  public class MergeSort {
      public static void merge(int[] arr, int l, int m, int r) {
          int n1 = m - l + 1;
          int n2 = r - m;
          int[] L = new int[n1];
          int[] R = new int[n2];
          for (int i = 0; i < n1; i++)
              L[i] = arr[l + i];
          for (int j = 0; j < n2; j++)
              R[j] = arr[m + 1 + j];
          int i = 0, j = 0, k = l;
          while (i < n1 && j < n2) {
              if (L[i] <= R[j]) {
                  arr[k] = L[i];
                  i++;
              } else {
                  arr[k] = R[j];
                  j++;
              }
              k++;
          }
          while (i < n1) {
              arr[k] = L[i];
              i++;
              k++;
          }
          while (j < n2) {
              arr[k] = R[j];
              j++;
              k++;
          }
      }
  
      public static void mergeSort(int[] arr, int l, int r) {
          if (l < r) {
              int m = l + (r - l) / 2;
              mergeSort(arr, l, m);
              mergeSort(arr, m + 1, r);
              merge(arr, l, m, r);
          }
      }
  }`,
    python: `
  def merge(arr, l, m, r):
      n1 = m - l + 1
      n2 = r - m
      L = arr[l:m+1]
      R = arr[m+1:r+1]
      i, j, k = 0, 0, l
      while i < len(L) and j < len(R):
          if L[i] <= R[j]:
              arr[k] = L[i]
              i += 1
          else:
              arr[k] = R[j]
              j += 1
          k += 1
      while i < len(L):
          arr[k] = L[i]
          i += 1
          k += 1
      while j < len(R):
          arr[k] = R[j]
          j += 1
          k += 1
  
  def mergeSort(arr, l, r):
      if l < r:
          m = l + (r - l) // 2
          mergeSort(arr, l, m)
          mergeSort(arr, m+1, r)
          merge(arr, l, m, r)
  `
  };
  